module InsiteScript {
    export function Init() {
        $("#scriptTable").DataTable({
            stateSave: true,
            autoWidth: false,
            scrollX: true,
            scrollY: '55vh',
            scrollCollapse: false,
            "order": [[0, "desc"]]
        });

        $("#btnAddNewInsiteScript").on("click", function () {
            Dialog.OpenModal('Nova skripta', 'Spremi', '/InsiteScript/Create');
        });

        $(".insite-script-edit").on("click", function () {
            var scriptName = $(this).data("script-name");
            var idScript = $(this).data("id-script");
            Dialog.OpenModal(`Izmjena skripte: ${scriptName}`, 'Izmjeni', `/InsiteScript/Edit/${idScript}`);
        });

        $(".insite-script-delete").on("click", function () {
            var idScript = $(this).data("id-script");
            Dialog.OpenModal('Brisanje skripte', 'Obriši', `/InsiteScript/Delete/${idScript}`);
        });

        $(".insite-script-details").on("click", function () {
            var idScript = $(this).data("id-script");
            Dialog.OpenDetailsModal('Detalji skripte', `/InsiteScript/Details/${idScript}`);
        });

        $("#btnGenerateInsiteScripts").on("click", function () {
            InsiteScript.GenerateScripts();
        });
    }

    export function DownloadScript(scriptName: string) {
        window.location.href = '/InsiteScript/DownloadFile/' + scriptName;
    }

    export function GenerateScripts() {
        window.location.href = '/InsiteScript/Generate';
    }
}

module InsiteScript.Create {
    export interface IScriptData {
        idScript: number,
        schema: string,
        scriptName: string,
        description: string,
        task: string,
        taskUrl: string,
        scriptChangeset: string,
        type: string,
        fileContainer: string,
        action: string
    }

    export function Init() {
        SetScriptName($("#SchemaList :selected").text());

        $("#SchemaList").on("change", function () {
            SetScriptName($("#SchemaList :selected").text());
        });

        $("#btnScriptModal").click(function () {
            $(this).prop("disabled", true);
            SaveScript("create", -1);
            $(this).prop("disabled", false);
        });
    }

    export function SaveScript(action: string, scriptId: number) {
        var scriptData: IScriptData = <IScriptData>{};

        if ($("input[type=radio]:checked").length == 0) {
            Notifications.GetNotification("Morate odabrati kojem tipu pripada skripta", "warning");
            return false;
        }

        scriptData.idScript = scriptId;
        scriptData.schema = $("#SchemaList :selected").text() as string;
        scriptData.scriptName = $("#ScriptName").val() as string;
        scriptData.description = $("#ScriptDescription").val() as string;
        scriptData.fileContainer = "skriptecrm";
        scriptData.type = $("input[type=radio]:checked").attr("id") as string;
        scriptData.task = $("#DimtTasksList").val() as string;
        scriptData.scriptChangeset = $("#ChangesetList option:selected").text();
        scriptData.action = action;

        var uploadFile = $("#FileUpload").get(0) as HTMLInputElement;

        PlsWait.ShowLoader(true);
        /*Ako je dodana nova skripta onda upload file-a*/
        if (uploadFile.files.length != 0) {

            /*Provjera dali je skripta u SQL formatu*/
            var lastDot = uploadFile.files[0].name.lastIndexOf('.');
            var scriptExtension = uploadFile.files[0].name.substring(lastDot + 1);

            if (scriptExtension.toUpperCase() !== "SQL") {
                Notifications.GetNotification("Skripta mora biti u SQL formatu", "warning");
                PlsWait.ShowLoader(false);
                return false;
            }

            var file = SetFileData(uploadFile, scriptData.scriptName);
            var ajaxParams: JQueryAjaxSettings = {};
            ajaxParams.url = '/InsiteScript/UploadFile/' + scriptData.schema;
            ajaxParams.type = 'POST';
            ajaxParams.contentType = false;
            ajaxParams.processData = false;
            ajaxParams.data = file;
            ajaxParams.success = (result) => {
                if (result.indexOf("Greška") == -1) {
                    Save(scriptData);
                }
                else {
                    Notifications.GetNotification(result.substring(7), "warning");
                }
            };
            ajaxParams.error = (err) => {
                Notifications.GetNotification(err.statusText, "danger");
                PlsWait.ShowLoader(false);
            };

            $.ajax(ajaxParams);
        }
        else if (uploadFile.files.length == 0 && action == "create") {
            Notifications.GetNotification("Niste odabrali skriptu", "warning");
            PlsWait.ShowLoader(false);
            return false;
        }
    }

    function Save(scriptData: IScriptData) {
        var ajaxParams: JQueryAjaxSettings = {};
        ajaxParams.url = '/InsiteScript/Create';
        ajaxParams.type = 'POST';
        ajaxParams.dataType = 'json';
        ajaxParams.contentType = 'application/json';
        ajaxParams.data = JSON.stringify(scriptData);
        ajaxParams.success = (result) => {
            $("#ScriptModal .close").click();
            PlsWait.ShowLoader(false);
            Notifications.GetNotificationWithProgressBar("Upload file", "success");
            window.location.href = '/InsiteScript/List';
        };
        ajaxParams.error = (err) => {
            PlsWait.ShowLoader(false);
            Notifications.GetNotification(err.statusText, "danger");
        };

        $.ajax(ajaxParams);
    }

    function SetScriptName(selOption) {
        var newName = $("#scriptNameHidd").val() + "_" + selOption;
        $("#ScriptName").val(newName);
    }

    function SetFileData(file: HTMLInputElement, fileName: string) {
        var fileUpload = file.files[0];
        var fileData = new FormData();

        fileData.set('script', fileUpload, fileName);

        return fileData;
    }

    export function DownloadScript(scriptName: string) {
        window.location.href = '/InsiteScript/DownloadFile/' + scriptName;
    }
}

module InsiteScript.Edit {
    export function Init() {
        $("#SchemaList").on("change", function () {
            var scriptName: string = $("#ScriptName").val() as string;
            scriptName = scriptName.split('INS_')[0];

            $("#ScriptName").val(scriptName + $("#SchemaList :selected").text());
        });

        $("#btnScriptModal").click(function () {
            var scriptId: number = parseInt($("#scriptId").val().toString());
            Create.SaveScript("update", scriptId);
        });
    }
}

module InsiteScript.Delete {
    export function Init() {
        $("#btnScriptModal").click(function () {
            var ajaxParams: JQueryAjaxSettings = {};
            ajaxParams.url = "/InsiteScript/Delete/" + $("#ScriptId").val();
            ajaxParams.type = 'POST';
            ajaxParams.contentType = 'application/json';
            ajaxParams.success = (result) => {
                $("#ScriptModal .close").click();
                PlsWait.ShowLoader(false);
                Notifications.GetNotificationWithProgressBar("Delete file", "success");
                window.location.href = '/InsiteScript/List';
            };
            ajaxParams.error = (err) => {
                PlsWait.ShowLoader(false);
                Notifications.GetNotification(err.statusText, "danger");
            };

            $.ajax(ajaxParams);
        });
    }
}

module InsiteScript.Details{
    export function Init() {
        $(".insite-script-download").on("click", function () {
            var scriptName = $(this).data("script-name");
            InsiteScript.DownloadScript(scriptName);
        });
    }
}

module InsiteScript.Generate {
    var dataTable;

    interface IGenerateScriptData {
        scriptId: string,
        scriptName: string
    }

    export function Init(): void {
        dataTable = $("#scriptTable").DataTable({
            "order": [[0, "desc"]]
        });

        $("#GenerateScripts").on("click", function () {
            var arrData: IGenerateScriptData[] = [];
            var $table = dataTable.data();

            PlsWait.ShowLoader(true);

            if ($table.length != 0) {
                for (var i = 0; i < $table.length; i++) {
                    arrData.push(AddRowScriptData($table[i]));
                }

                arrData.sort((a, b) => (a.scriptName > b.scriptName) ? 1 : ((b.scriptName > a.scriptName) ? -1 : 0));

                GetScripts(arrData);

                PlsWait.ShowLoader(false);
            }
            else {
                Notifications.GetNotification("Nema niti jedne skripte za generiranje", "warning");
                PlsWait.ShowLoader(false);
            }
        });

        $(".insite-script-generate-download").on("click", function () {
            var scriptName = $(this).data("script-name");
            InsiteScript.DownloadScript(scriptName);
        });
    }

    function ReloadPage(dateFrom: string, dateTo: string) {
        window.location.href = '/InsiteScript/Generate';
    }

    function AddRowScriptData(tableRow): IGenerateScriptData {
        var scriptData: IGenerateScriptData = <IGenerateScriptData>{};
        scriptData.scriptId = tableRow[0]; /*Šifra skripte*/
        scriptData.scriptName = tableRow[1]; /*Naziv skripte*/

        return scriptData;
    }

    function GetScripts(arrData: IGenerateScriptData[]) {
        var ajaxParams: JQueryAjaxSettings = {};
        ajaxParams.url = '/InsiteScript/Prepare';
        ajaxParams.type = 'POST';
        ajaxParams.dataType = 'json';
        ajaxParams.contentType = 'application/json';
        ajaxParams.traditional = true;
        ajaxParams.data = JSON.stringify(arrData);
        ajaxParams.processData = false;
        ajaxParams.success = (result) => {
            var key: string = result;
            var newTab = window.open('/InsiteScript/DownloadFiles/' + key, '_blank');
            CheckIfFileIsDownloaded(newTab);
        };
        ajaxParams.error = (err) => {
            Notifications.GetNotification(err.statusText, "danger");
            PlsWait.ShowLoader(false);
        };

        $.ajax(ajaxParams);
    }

    function CheckIfFileIsDownloaded(newTab) {
        if (newTab.closed) {
            PlsWait.ShowLoader(false);
            window.location.href = '/Dashboard'; /*Vraćanje na dashboard*/
            window.focus();
        }
        else {
            setTimeout(function () { CheckIfFileIsDownloaded(newTab) }, 500);
        }
    }
}